import { Component, Inject, Output, EventEmitter } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-generic-bottom-sheet',
  templateUrl: './generic-bottom-sheet.component.html',
  styleUrls: ['./generic-bottom-sheet.component.scss'],
})
export class GenericBottomSheetComponent {
  @Output() closeEvent = new EventEmitter<void>();

  constructor(
    private bottomSheetRef: MatBottomSheetRef<GenericBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { content: any }
  ) {}

  close() {
    this.closeEvent.emit();
    this.bottomSheetRef.dismiss();
  }
}
